import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

const NOTIFICATION_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error',
    UPGRADE: 'upgrade',
    INFO: 'info',
};

// Set the classNames and CTA button text for the Toast Notification component
const getNotificationDetails = (notificationType) => {
    switch (notificationType) {
        case NOTIFICATION_TYPES.SUCCESS:
            return {
                backgroundColor: 'bg-green-notif',
                iconStyle: 'fa-check-circle font-white',
                callToActionText: 'View',
            };
        case NOTIFICATION_TYPES.ERROR:
            return {
                backgroundColor: 'bg-error-notif',
                iconStyle: 'fa-exclamation-triangle font-white',
                callToActionText: 'Retry',
            };
        case NOTIFICATION_TYPES.UPGRADE:
            return {
                backgroundColor: 'bg-upgrade-notif',
                iconStyle: 'fa-arrow-circle-up font-white',
                callToActionText: 'Upgrade',
            };
        case NOTIFICATION_TYPES.INFO:
            return {
                backgroundColor: 'bg-info-notif',
                iconStyle: 'fa-info-circle font-white',
                callToActionText: 'Show',
            };
        default:
            throw new Error('Invalid notification type');
    }
};
function ToastNotification({
    notificationType = NOTIFICATION_TYPES.SUCCESS,
    msg = '',
    isVisible = false,
    ctaEvent = '',
    action = () => { },
}) {
    // State to control visibility
    const [visible, setVisible] = useState(false);
    const { backgroundColor, iconStyle, callToActionText } = getNotificationDetails(notificationType);
    const showActionButton = !!ctaEvent;

    // Effect to hide the notification after the specified duration
    useEffect(() => {
        let timer;
        setVisible(isVisible);
        if (isVisible) {
            if (notificationType !== NOTIFICATION_TYPES.ERROR) {
                timer = setTimeout(() => {
                    setVisible(false);
                }, 2500);
            }
        }
        return () => {
            clearTimeout(timer);
            setVisible(false);
        };
    }, [isVisible, notificationType]);

    const closeToast = () => {
        setVisible(false);
    };

    return (
        <CSSTransition
            in={visible}
            timeout={500}
            classNames="fade"
            tabIndex="0"
            aria-label="Toast Notification"
            unmountOnExit
        >
            <div
                role='alert'
                className={`toast-notification margin-l-16px margin-r-16px margin-b-16px md-margin-l-32px md-margin-r-32px border-radius-6px ${backgroundColor}`}
            >
                <div className="toast-notification-container flex align-items-center justify-content-space-between">
                    <div className="flex align-items-center">
                        <i role='img' aria-label='Toast Notification Icon' className={`fa text-align-center margin-r-16px ${iconStyle} notif-icon`}></i>
                        <p className='block font-size-16px margin-0px' tabIndex="0" aria-label={msg}>{msg}</p>
                    </div>
                    {showActionButton ? <button
                        className='btn btn--small action-btn margin-l-16px'
                        onClick={action}
                    >{callToActionText}</button> : null
                    }
                    <div className="flex align-items-center">
                        <hr />
                        <i className="fa fa-times fa-close cursor-pointer" aria-label="Close" tabIndex="0" onClick={closeToast} onKeyDown={closeToast}></i>
                    </div>
                </div>

            </div>
        </CSSTransition>
    );
}

ToastNotification.propTypes = {
    notificationType: PropTypes.oneOf(Object.values(NOTIFICATION_TYPES)).isRequired,
    msg: PropTypes.string,
    isVisible: PropTypes.bool,
    ctaEvent: PropTypes.string,
    action: PropTypes.func,
};

export { ToastNotification, NOTIFICATION_TYPES };
